import React, {Component} from 'react';

class AppFooter extends Component {

    render() {
        return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    className="layout-footer p-d-flex p-ai-center p-p-4 p-shadow-2">
        </div>
    }
}

export default AppFooter;
